import { useInitPartner } from "../hooks/middleware/useInitPartner";
import { useCheckCallRoute } from "../hooks/middleware/useCheckCallRoute";

export function MiddlewareWrapper() {
  useInitPartner();
  useCheckCallRoute();
  return null;
}
